import { Phase } from "./phase";

interface AnnualPlanPhaseData {
  id?: number;
  weekFrom?: number;
  weekTo?: number;
  annualPlanId?: number;
  phaseId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  phase?: Phase;

}

export class AnnualPlanPhase {
  public static getNonTranslatableFields(): string[] { return ['id', 'weekFrom', 'weekTo', 'annualPlanId', 'phaseId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'weekFrom', 'weekTo', 'annualPlanId', 'phaseId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  weekFrom?: number;
  weekTo?: number;
  annualPlanId?: number;
  phaseId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  phase?: Phase;

  public static fromAPI(data: AnnualPlanPhaseData): AnnualPlanPhase {
    return new AnnualPlanPhase(data);
  }

  public static fromAPIList(data: AnnualPlanPhaseData[]): AnnualPlanPhase[] {
    return data.map((item: AnnualPlanPhaseData) => AnnualPlanPhase.fromAPI(item));
  }

  constructor({id, weekFrom, weekTo, annualPlanId, phaseId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId, phase} : AnnualPlanPhaseData) {
    this.id = id;
    this.weekFrom = weekFrom;
    this.weekTo = weekTo;
    this.annualPlanId = annualPlanId;
    this.phaseId = phaseId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;

    this.phase = phase;
  }

  public toJson(): AnnualPlanPhaseData {
    return {
      id: this.id,
      weekFrom: this.weekFrom,
      weekTo: this.weekTo,
      annualPlanId: this.annualPlanId,
      phaseId: this.phaseId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId,
    };
  }
}
